module.exports = __webpack_public_path__ + "img/box-dollar.063adf.svg";